import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PRODUCT_OPTION_DISPLAY_LIMIT } from 'pages/ProductOptions/ProductOptionConstants';
import { PageDetails } from 'types/common/Table';
import { ProductOptionFormType } from 'types/product/productOptionTypes';

interface ProductOptionState {
  countSubmit: number;
  showAllValidateErrors: boolean;
  isEdit: boolean;
  error: string;
  success: string;
  modalBackdrop: boolean;
  loading: boolean;
  errorMsg: boolean;
  alertMessage: string;
  PageDetails: PageDetails;
  NameExists: boolean;
  FormErrorCount: number;
  ProductOptionValues: ProductOptionFormType;
  TotalProductOptions: number;
}

export const initialState: ProductOptionState = {
  countSubmit: 0,
  showAllValidateErrors: false,
  isEdit: false,
  error: '',
  success: '',
  modalBackdrop: false,
  loading: false,
  errorMsg: false,
  alertMessage: '',
  PageDetails: {
    entriesPerPage: PRODUCT_OPTION_DISPLAY_LIMIT,
    currentPage: 0,
    inputPageValue: 1,
  },
  NameExists: false,
  FormErrorCount: 0,
  ProductOptionValues: {
    name: '',
    optionType: '1',
    forceType: '1',
    // active: '1',
    options: [{ name: '', additionalPrice: '0.00' }],
  },
  TotalProductOptions: 0,
};

const ProductOptionSlice = createSlice({
  name: 'ProductOption',
  initialState,
  reducers: {
    setCountSubmit: (state) => {
      state.countSubmit += 1;
    },
    setShowAllValidateErrors: (state, action) => {
      state.showAllValidateErrors = action.payload;
    },
    setIsEdit: (state, action) => {
      state.isEdit = action.payload;
    },
    apiError(state, action) {
      state.error = action.payload.message;
      state.loading = true;
      state.errorMsg = true;
    },
    apiSuccess(state, action) {
      state.error = '';
      state.success = action.payload.message;
      state.modalBackdrop = true;
      state.loading = false;
      state.errorMsg = false;
      state.showAllValidateErrors = false;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setSuccess: (state, action: PayloadAction<string>) => {
      state.success = action.payload;
    },
    setModalBackdrop: (state, action) => {
      state.modalBackdrop = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAlertMessage: (state, action: PayloadAction<string>) => {
      state.alertMessage = action.payload;
    },
    setTotalProductOptions: (state, action) => {
      state.TotalProductOptions = action.payload;
    },
    setProductOptionValues: (state, action) => {
      state.ProductOptionValues = action.payload;
    },
    resetProductOption: (state) => {
      state.countSubmit = 0;
      state.showAllValidateErrors = false;
      state.isEdit = false;
      state.error = '';
      state.success = '';
      state.modalBackdrop = false;
      state.loading = false;
      state.errorMsg = false;
      state.alertMessage = '';
      state.ProductOptionValues = {
        name: '',
        optionType: '1',
        forceType: '1',
        // active: '1',
        options: [{ name: '', additionalPrice: '0.00' }],
      };
    },
    setEntriesPerPage: (state, action) => {
      state.PageDetails.entriesPerPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.PageDetails.currentPage = action.payload;
      state.PageDetails.inputPageValue = action.payload + 1;
    },
    setInputPageValue: (state, action) => {
      state.PageDetails.inputPageValue = action.payload;
    },
    setNameExists: (state, action) => {
      state.NameExists = action.payload;
    },
    setFormErrorCount: (state, action) => {
      state.FormErrorCount = action.payload;
    },
  },
});

export const {
  setCountSubmit,
  setShowAllValidateErrors,
  setIsEdit,
  apiError,
  apiSuccess,
  setError,
  setSuccess,
  setModalBackdrop,
  setLoading,
  setAlertMessage,
  setTotalProductOptions,
  setProductOptionValues,
  resetProductOption,
  setEntriesPerPage,
  setCurrentPage,
  setInputPageValue,
  setNameExists,
  setFormErrorCount,
} = ProductOptionSlice.actions;

export default ProductOptionSlice.reducer;
